import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { BaseComponent } from './components/base-component/base.component';
import { UsersListComponent } from './components/users-list/users-list.component';
import { ReceiversListComponent } from './components/receivers-list/receivers-list.component';
import { ViewEditUserPageComponent } from './pages/view-edit-user-page/view-edit-user-page.component';
import { AddUserComponent } from './components/add-user/add-user.component';
// import { ContractListComponent } from './components/contract-list/contract-list.component';
import { PermitAccessControlComponent } from './components/permit-access-control/permit-access-control.component';
import { PermitAccessControlListComponent } from './components/permit-access-control-list/permit-access-control-list.component';
import { PermittedAccessListComponent } from './components/permitted-access-list/permitted-access-list.component';
import { LocationsListComponent } from './components/locations-list/locations-list.component';
import { ViewEditUserComponent } from './components/view-edit-user/view-edit-user.component';
import { GateToGateComponent } from './components/gate-to-gate/gate-to-gate.component';
import { AddLocationComponent } from './components/add-location/add-location.component';
import { LocationsComponent } from './components/locations/locations.component';
import { UserFormComponent } from './components/user-form/user-form.component';
import { UserParamsComponent } from './components/user-params/user-params.component';
import { PreviewMapComponent } from './components/preview-map/preview-map.component';
import { MobileNumberComponent } from './components/mobile-number/mobile-number.component';
import { AuthHighlightsComponent } from './components/auth-highlights/auth-highlights.component';
import { WeightFieldComponent } from './components/weight-field/weight-field.component';
import { NewGateToGateComponent } from './components/new-gate-to-gate/new-gate-to-gate.component';
import { ShippingCardComponent } from './components/shipping-card/shipping-card.component';
import { PlateNumberViewComponent } from './components/plate-number-view/plate-number-view.component';
import { DashboardCardComponent } from './components/dashboard-card/dashboard-card.component';
import { StatsCardComponent } from './components/stats-card/stats-card.component';
import { GateDefinitionComponent } from './components/gate-definition/gate-definition.component';
import { LanguageService } from '@core/services';
import i18n from './i18n';
import { GateToGateTimelineComponent } from './components/gate-to-gate-timeline/gate-to-gate-timeline.component';
import { RenewContractComponent } from '@shared-features/components/renew-contract/renew-contract.component';
import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { BaseChartComponent } from './components/base-chart/base-chart.component';
import { AvlSummaryComponent } from './components/avl-summary/avl-summary.component';
import { ShipmentTrackingMapComponent } from './components/shipment-tracking-map/shipment-tracking-map.component';
import { ChartsModule } from 'ng2-charts';
import { LegendLabelsComponent } from './components/legend-labels/legend-labels.component';
import { GateToGateMarkerComponent } from './components/gate-to-gate-marker/gate-to-gate-marker.component';
import { AvlOverSpeedMarkerComponent } from './components/avl-over-speed-marker/avl-over-speed-marker.component';
import { ShipmentStopMarkerComponent } from './components/shipment-stop-marker/shipment-stop-marker.component';
import { UndetailedOrdersListComponent } from './components/undetailed-orders-list/undetailed-orders-list.component';
import { ShipmentAssignmentActionWrapperComponent } from './components/shipment-assignment-action-wrapper/shipment-assignment-action-wrapper.component';
import { ShipmentAssignmentAction } from './components/shipment-assignment-action/shipment-assignment-action.component';
import { MapElementDirective } from '@shared-features/directives/map-element.directive';
import { OrdersListItemComponent } from './components/orders-list-item/orders-list-item.component';
import { OrdersListTimelineComponent } from './components/orders-list-timeline/orders-list-timeline.component';
import { FleetSurveyDialogComponent } from './components/fleet-survey-dialog/fleet-survey-dialog.component';
import { InformationDialogComponent } from './components/information-dialog/information-dialog.component';
import { PasswordExpiryDialogComponent } from './components/password-expiry-dialog/password-expiry-dialog.component';
import { AddContactComponent } from './components/add-contact/add-contact.component';
import { PhoneNumberFieldComponent } from './components/phone-number-field/phone-number-field.component';
import { AddLocationDialogComponent } from './components/add-location-dialog/add-location-dialog.component';

const COMPONENTS = [
  BaseComponent,
  UsersListComponent,
  ReceiversListComponent,
  ViewEditUserPageComponent,
  AddUserComponent,
  RenewContractComponent,
  // ContractListComponent ,
  PermitAccessControlComponent,
  PermitAccessControlListComponent,
  PermittedAccessListComponent,
  LocationsListComponent,
  ViewEditUserComponent,
  GateToGateComponent,
  AddLocationComponent,
  LocationsComponent,
  UserFormComponent,
  UserParamsComponent,
  PreviewMapComponent,
  UserParamsComponent,
  MobileNumberComponent,
  AuthHighlightsComponent,
  WeightFieldComponent,
  NewGateToGateComponent,
  ShippingCardComponent,
  PlateNumberViewComponent,
  DashboardCardComponent,
  StatsCardComponent,
  GateDefinitionComponent,
  GateToGateTimelineComponent,
  BarChartComponent,
  BaseChartComponent,
  AvlSummaryComponent,
  ShipmentTrackingMapComponent,
  LegendLabelsComponent,
  ShipmentStopMarkerComponent,
  AvlOverSpeedMarkerComponent,
  GateToGateMarkerComponent,
  UndetailedOrdersListComponent,
  ShipmentAssignmentActionWrapperComponent,
  ShipmentAssignmentAction,
  MapElementDirective,
  OrdersListItemComponent,
  OrdersListTimelineComponent,
  FleetSurveyDialogComponent,
  InformationDialogComponent,
  PasswordExpiryDialogComponent,
  AddContactComponent,
  PhoneNumberFieldComponent,
  AddLocationDialogComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CommonModule, SharedModule, ChartsModule],
  exports: [...COMPONENTS, ChartsModule],
})
export class SharedFeaturesModule {
  constructor(languageService: LanguageService) {
    languageService.registerModule(i18n);
  }
}
